import { DynamicFormContext } from "@iewcasia/Widgets/DynamicForm/DynamicForm";
import React from "react";

/**
 * Registers Field Key(s) for duplicate detection on Dynamic Form submit.
 * Pass the CMS widget id and one or more Field Keys used by the widget.
 */
export const useRegisterDynamicFormFieldKeys = (
    widgetId: string,
    fieldKeys: Array<string | undefined | null>,
    enabled = true,
) => {
    const { registerFieldKeys, unregisterFieldKeys } = React.useContext(DynamicFormContext);
    const normalizedKeys = fieldKeys
        .map(key => (key || "").trim())
        .filter(key => !!key);

    const keysSignature = normalizedKeys.join("|");

    React.useEffect(() => {
        if (!enabled || !widgetId || !registerFieldKeys) {
            return;
        }

        registerFieldKeys(widgetId, normalizedKeys);
        return () => {
            unregisterFieldKeys?.(widgetId);
        };
    }, [enabled, widgetId, keysSignature, registerFieldKeys, unregisterFieldKeys]);
};
